module.exports = __webpack_public_path__ + "img/slider-swipe-instruction.e18b39da.svg";